import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ModalComponent = ({
    show,
    handleClose,
    title,
    fields,
    formData,
    handleChange,
    handleSubmit,
    submitText = "Confirmer",
    closeText = "Annuler"
}) => {
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {fields.map((field, index) => (
                        <Form.Group key={index} className="mb-3 w-100">
                            <Form.Label>{field.label}</Form.Label>
                            {field.type === "select" ? (
                                <Form.Select
                                    name={field.name}
                                    value={formData[field.name] || ""}
                                    onChange={handleChange}
                                    required={field.required || false}
                                    className="w-100"
                                >
                                    <option value="">{field.placeholder || "Sélectionnez une option"}</option>
                                    {field.options && field.options.map((option, idx) => (
                                        <option key={idx} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            ) : (
                                <Form.Control
                                    type={field.type || "text"}
                                    name={field.name}
                                    value={formData[field.name] || ""}
                                    onChange={handleChange}
                                    placeholder={field.placeholder || ""}
                                    required={field.required || false}
                                />
                            )}
                        </Form.Group>
                    ))}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <strong>{closeText}</strong>

                </Button>
                <Button variant="success" onClick={handleSubmit}>
                    <strong>{submitText}</strong>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalComponent;
